/**
 * Created by gzk on 2017-10-08.
 */
import { Injectable }     from '@angular/core';
import {LoadingController, ToastController} from 'ionic-angular';

@Injectable()
export class NoticeService {
    static TOAST_POS_BOTTOM: string = 'bottom';
    static TOAST_POS_TOP: string = 'top';
    static TOAST_POS_MIDDLE: string = 'middle';
    loading:any;

    constructor(private toastCtrl: ToastController,public loadingCtrl: LoadingController) {

    }

    showLoading()
    {
        this.loading = this.loadingCtrl.create({
            // content:'overdose...'
          duration: 3000,
        });
        this.loading.present();
    }

    dismissLoading()
    {
        if(this.loading)
        {
            this.loading.dismiss();
          this.loading=null;
        }
    }


    // 显示 toast提示
    showToast(message: string, position: string = NoticeService.TOAST_POS_MIDDLE)
    {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 1500,
            position: position,
            cssClass: "vd-toast",
        });
        toast.present();

        return toast;
    }

    showMsg(message: string = "服务器开小差了!", position: string = NoticeService.TOAST_POS_MIDDLE)
    {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 1500,
            position: position,
            cssClass: "vd-toast",
        });
        toast.present();
        this.dismissLoading();
        return toast;
    }

    /*showNoticeByToast(code: Number, msg: string) {
     let m = '';
     if(code == 1) {
     m = '提示：' + msg + '！';
     } else {
     m = '错误' + code + '：' + msg + '！';
     }

     return this.showToast(m);
     }*/

    showNoticeByToast(code: Number, msg: string) {
        let m = '';

        if(msg && msg.length > 0) {
            if(msg.charAt(msg.length - 1) == '!' || msg.charAt(msg.length - 1) == '！') {
                msg = msg.substr(0, msg.length - 1);
            }
        }

        if(code == 1) {
            m = '提示：' + msg + '！';
        } else {
            m = '错误' + code + '：' + msg + '！';
        }

        return this.showToast(m);
    }
}



// WEBPACK FOOTER //
// ./src/providers/api-service/notice-service.ts